import React, { useEffect, useState } from 'react'

import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { format, parseISO } from 'date-fns';
import Loading from '../../Components/Input/Loading';
import getServices from '../../Services/get-service';
import Constant from '../../Constant';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { getBranding } from '../../utils/getBranding';
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'var(--color-primary)',
    color: 'white',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const EpinTable = () => {
  const branding = getBranding();
  const [transaction, setTransaction] = useState([])
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false)
  const [rowsPerPage, setRowsPerPage] = useState(10);
   const [filterValue, setFilterValue] = useState('all')
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  useEffect(() =>{
    setLoading(true)
    getServices.getEpin().then(
        (response) => {
          
          setTransaction(response.data.data.reverse());
          console.log(response.data.data)
          setLoading(false)
        },
        (error) => {
          
        }
      )
}, [])
const downloadEpin = (id) =>{
    setLoading(true)
    getServices.downloadEpin(id).then(
        (res) => {
          
            console.log(res.data.data);
            const doc = new jsPDF();
            const pageWidth = doc.internal.pageSize.width;
            const margin = 6;
            const itemWidth = (pageWidth - 4 * margin) / 3; // Calculate the width of each item to fit 2 per row
            const itemPadding = 3; // Padding inside each item
      
            let xPosition = margin;
            let yPosition = margin;
      
            doc.setFontSize(10);
      
            res.data.data.forEach((item, index) => {
              // Calculate the height of the item based on the content
              const lines = [
                `Business name: ${item.businessName}`,
                `Price: ${item.price}`,
                `Pin: ${item.pin}`,
                `Serial No: ${item.serialNo}`,
                `Date Created: ${(item.dateCreated)?.split("T")[0]}`,
                `Powered by: ${item.poweredBy}`,
                `To Use: ${item.toUse}`,
              ];
              const itemHeight = (lines.length * 7) + 2 * itemPadding; // Adjust height based on the number of lines
      
              // Add new page if height exceeds page limit
              if (yPosition + itemHeight > doc.internal.pageSize.height - margin) {
                doc.addPage();
                yPosition = margin;
              }
      
              // Draw border for each item
              doc.setLineWidth(0.5);
              doc.rect(xPosition, yPosition, itemWidth, itemHeight);
      
              // Add text inside the item
              let textYPosition = yPosition + itemPadding + 5; // Start text a bit down from the top
              lines.forEach(line => {
                doc.text(line, xPosition + itemPadding, textYPosition, { maxWidth: itemWidth - 2 * itemPadding });
                textYPosition += 7; // Adjust text position
              });
      
              xPosition += itemWidth + margin; // Move to the next item position
      
              // Reset xPosition and move yPosition down if we've filled a row
              if ((index + 1) % 3 === 0){
                xPosition = margin;
                yPosition += itemHeight + margin;
              }
            });
            setLoading(false)
            doc.save('epin.pdf');
        },
        (error) => {
            setLoading(false)
        }
      )
}

let filteredData =  filterValue === 'all'?
transaction
:
transaction.filter(item => item.transType  === filterValue);

  return (
    <div>
     <Loading
      open={loading}
    />
      <h1 className=' font-bold'>E-pin Transaction</h1>
     <div className=' mb-6 mt-2 grid grid-cols-3 gap-3'>
     
     </div>
    <Paper className=' ' sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: 600 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead >
            <TableRow >
            <StyledTableCell> Batch Id</StyledTableCell>
            <StyledTableCell align="left">Date/Time</StyledTableCell>
            <StyledTableCell align="left">Amount</StyledTableCell>
            <StyledTableCell align="left">Status</StyledTableCell>
            <StyledTableCell align="left">Action</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((tran) => (
                
            <TableRow
              key={tran.transactionDate}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
             <span className=' capitalize'>{tran.keyId}</span> 
              </TableCell>
              <TableCell align="left">{format(parseISO(tran["purchased Date"]), 'MMM d yyyy hh:mm:ss a')}</TableCell>
              <TableCell align="left"> NGN {tran.amount}</TableCell>
              {/* <TableCell align="left">{tran.narration}</TableCell> */}
              <TableCell align="left">{tran.isUsed ? 'Used':"Unused"} </TableCell>
              <TableCell align="left"><span onClick={() => downloadEpin(tran.keyId)} style={{ backgroundColor: branding.color.primary }} className='  p-2 rounded-md text-white'>Download </span> </TableCell>
            </TableRow>
          ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={filteredData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      {filteredData.length === 0 && <p className=' text-center font-bold text-red-700 mt-5'>No transaction</p>}
    </Paper>
    </div>
  )
}

export default EpinTable

